import { call, put, take } from 'redux-saga/effects';
import { KPIDataApiType } from '../../api/lelyBackend/kpiDataApi';
import {
  fetchKPIData,
  setKPIData,
  setKPIError,
} from '../../reducers/kpiDataSlice';
import { KPIRequestParams } from '../../reducers/types/kpiDataTypes';
import { AwaitedApiResultType } from '../../common/types';
import withLoading from '../../sagas/loadingSaga';

export default function* kpiSaga(api: KPIDataApiType) {
  while (true) {
    const kpiAction = yield take(fetchKPIData.type);
    yield* withLoading(function* () {
      yield call(getKPIDataFromApi, api, kpiAction.payload);
    });
  }
}

function* getKPIDataFromApi(api: KPIDataApiType, params: KPIRequestParams) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const entitySettingsData: AwaitedApiResultType<typeof api.getKPIData> =
      yield call(api.getKPIData, params);

    yield put(
      setKPIData({
        ...entitySettingsData.data,
        defaultDomain: [params.fromDate, params.toDate],
      }),
    );
  } catch (error: any) {
    yield put(setKPIError(error));
  }
}
